import { useState, useContext, useEffect, useRef } from "react"
import { BtnLoader, CSelect, toast, CInputText, CInputPassword, CToggle, CModal } from "../../components/widget"
import { ContextNav, ContextDashboard, ContextLoading } from "../../context";
import { AddRollCallApi, ListJobApi, ListGroupJobApi, SingleUserApi, EditUserApi } from "../../api";
import { useNavigate, useParams, Link } from "react-router-dom";
import Cropper from "react-cropper";

export const UsersEdit = () => {
    const navigate = useNavigate()
    const params = useParams();
    const formRef: any = useRef()
    const CtxNav = useContext(ContextNav)
    const CtxDash = useContext(ContextDashboard)
    const CtxLoad = useContext(ContextLoading)
    const [listJob, setListJob] = useState<any>({ 'jobs': [], 'group_jobs': [], })
    const [detailData, setDetailData] = useState<any>()
    const [selectGroupId, setSelectGroupId] = useState<any>(null)
    const [visibleImageModal, setVisibleImageModal] = useState<boolean>(false)
    const [isSelecetNewImage, setisSelecetNewImage] = useState<boolean>(false)
    const [image, setImage] = useState();
    const [cropData, setCropData] = useState<any>(null);
    const [cropper, setCropper] = useState<any>();

    const getCropData = () => {
        if (typeof cropper !== "undefined") {
            setCropData(cropper.getCroppedCanvas().toDataURL());
            setVisibleImageModal(false)
            setisSelecetNewImage(true)
        }
    };

    const selectImage = (e: any) => {
        e.preventDefault();
        let files;
        if (e.dataTransfer) {
            files = e.dataTransfer.files;
        } else if (e.target) {
            files = e.target.files;
        }
        const reader = new FileReader();
        reader.onload = () => {
            setImage(reader.result as any);
        };
        reader.readAsDataURL(files[0]);
        setVisibleImageModal(true)
    }

    const onFinishAdd = async (e: any) => {
        e.preventDefault()
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await EditUserApi(formRef, detailData, isSelecetNewImage, cropData)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast("با موفقیت ویرایش گردید", { type: "success" })
            navigate('/p/users');
        }
        else {
            toast(res.message, { type: "error" })
        }
    }

    const getDetail = async () => {
        let res = await SingleUserApi(params.id)
        CtxLoad.setDisplayLoadingBlur(false)
        if (res.success) {
            formRef.current['username'].value = res.data.username;
            formRef.current['name'].value = res.data.profile.fname;
            formRef.current['family'].value = res.data.profile.lname;
            formRef.current['imei'].value = res.data.IMEI;
            formRef.current['group_job'].value = res.data?.job_group.id;
            formRef.current['job'].value = res.data?.jobs[0].id;
            formRef.current['year'].value = res.data.profile.birthday.slice(0, 4);
            formRef.current['month'].value = +res.data.profile.birthday.slice(5, 7);
            formRef.current['day'].value = res.data.profile.birthday.slice(8, 11);
            formRef.current['status'].checked = res.data.status == 1 ? true : false;
            formRef.current['tskePhoto'].checked = res.data.profile.is_recognizable == 1 ? true : false;
            setCropData(res.data.profile.avatar)
            setDetailData(res.data)
            setSelectGroupId(res.data?.job_group.id)
        }
    }

    const getListGroupJob = async (jobs: any) => {
        let res = await ListGroupJobApi()
        if (res.success) {
            let data: any = { ...listJob };
            data['group_jobs'] = res.data;
            data['jobs'] = jobs;
            setListJob(data)
        }
    }

    const getListJob = async () => {
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await ListJobApi()
        if (res.success) {
            await getListGroupJob(res.data);
        }
        getDetail();
    }

    useEffect(() => {
        document.title = "ویرایش پرسنل | دایان"
        CtxNav.setActiveMenuItem({ 'item': 2, 'subItem': 0, })
        getListJob();
        
    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">ویرایش پرسنل </h1>

            <form ref={formRef} onSubmit={onFinishAdd} className=" w-full  flex flex-col shadow sm:rounded-xl rounded-lg bg-white py-[15px] sm:py-[30px] sm:px-[20px] px-[10px]">

                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px]  border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <label className="w-[130px] h-[130px] bg-dayan-gray-50 rounded-full shadow flex justify-center items-center cursor-pointer">
                            {cropData == null ?
                                <>
                                    <div className="w-[120px] h-[120px] border border-dashed border-[#afacac] rounded-full flex justify-center items-center flex-col text-xs">
                                        <svg x="0px" y="0px" viewBox={'0 0 218.166 218.166'} className={`  h-7 mb-2 fill-dayan-gray-80 `}>
                                            <use xlinkHref="/assetes/svg/photo.svg#photo" />
                                        </svg>
                                        <span>انتخاب تصویر کاربر</span>
                                    </div>
                                </>
                                :
                                <div className="w-[120px] h-[120px] border border-dashed border-[#afacac] rounded-full flex justify-center items-center flex-col text-xs">
                                    <img src={cropData} className="w-full h-full rounded-full" />
                                </div>
                            }
                            <input onChange={(e: any) => selectImage(e)} type={'file'} className="hidden" />
                        </label>
                    </div>
                </div>

                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-[50%] h-full pl-1">
                                <CInputText name="name" title="نام" type="text" />
                            </div>
                            <div className=" w-[50%] h-full pr-1">
                                <CInputText name="family" title="نام خانوادگی" type="text" />
                            </div>
                        </div>
                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-10 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-[50%] h-full pl-1">
                                <CInputPassword name="password" title="رمز عبور" />
                            </div>
                            <div className=" w-[50%] h-full pr-1">
                                <CInputText name="username" title="شماره پرسنلی" type="text" deisable={true} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-[50%] h-full pl-1">
                                <CSelect name="group_job" placeholder={'گروه شغلی'} title="گروه شغلی" border={true} onChange={(e: any) => {setSelectGroupId(e.target.value);}} required={true}>
                                    {listJob.group_jobs.map((item: any, index: number) =>
                                        <option key={index} value={item.id}>{item.name}</option>
                                    )}
                                </CSelect>
                            </div>
                            <div className=" w-[50%] h-full pr-1">
                                <CSelect name="job" placeholder={'شغل'} title="شغل" border={true} required={true}>
                                    {listJob.jobs.map((item: any, index: number) =>
                                        <>
                                            {selectGroupId == item.job_group_id &&
                                                <option key={index} value={item.id}>{item.name}</option>
                                            }
                                        </>
                                    )}
                                </CSelect>
                            </div>
                        </div>
                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-12 items-center pl-0 sm:pl-2 relative">
                            <span className="text-[11px] top-[-35px] left-0 right-0 mx-auto text-center absolute">تاریخ تولد</span>
                            <div className=" w-[50%] h-full pl-1">
                                <CSelect name="day" placeholder={'روز'} title="روز" border={true} required={true}>
                                    {['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'].map((item: any, index: number) =>
                                        <option key={index} value={item}>{item}</option>
                                    )}
                                </CSelect>
                            </div>
                            <div className=" w-[50%] h-full pr-1">
                                <CSelect name="month" placeholder={'ماه'} title="ماه" border={true} required={true}>
                                    {monthList.map((item: any, index: number) =>
                                        <option key={index} value={item.value}>{item.key}</option>
                                    )}
                                </CSelect>
                            </div>
                            <div className=" w-[50%] h-full pr-1">
                                <CSelect name="year" placeholder={'سال'} title="سال" border={true} required={true}>
                                    {yearsList.map((item: any, index: number) =>
                                        <option key={index} value={item}>{item}</option>
                                    )}
                                </CSelect>
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" md:w-[50%] w-full h-full pl-1">

                                <div className="flex flex-col mb-[30px] transition-all">
                                    <div className="flex relative px-[7px] min-h-[50px] rounded-[5px] items-center border border-dayan-gray-100 mb-[3px] focus-within:border-2 focus-within:border-dayan-orange-50">
                                        <span className="text-[12px] text-dayan-gray-100 absolute bg-white top-[-12px] right-[15px] px-[10px]">IMEI</span>
                                        <input name={'imei'} className={` w-[calc(100%-35px)] h-[35px] text-sm focus:outline-none cursor-not-allowed`} type={'text'} disabled />
                                        {detailData?.IMEI != null &&
                                            <div onClick={() => { formRef.current['imei'].value = "" }} className=" w-[35px] h-[35px] flex justify-center items-center cursor-pointer">
                                                <svg x="0px" y="0px" viewBox="0 0 512 512" className={`  h-5 fill-dayan-gray-100 `}>
                                                    <use xlinkHref="/assetes/svg/trash.svg#trash" />
                                                </svg>
                                            </div>
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-[50%] h-full pl-1 flex items-center">
                                <span className="text-sm mx-2">فعال</span>
                                <div className="flex flex-col justify-center items-center">
                                    <span className="text-[10px]  mb-2 text-center ">وضعیت پرسنل</span>
                                    <CToggle name="status" defaultChecked={true} />
                                </div>
                                <span className="text-sm mx-2">غیر فعال</span>
                            </div>
                            <div className=" w-[50%] h-full pr-1 flex items-center">
                                <span className="text-sm mx-2">روشن</span>
                                <div className="flex flex-col justify-center items-center">
                                    <span className="text-[10px]  mb-2 text-center ">عکس برداری</span>
                                    <CToggle name="tskePhoto" defaultChecked={true} />
                                </div>
                                <span className="text-sm mx-2">خاموش</span>
                            </div>
                        </div>
                    </div>
                </div>


                <div className=" w-full mt-[40px] flex items-center">
                    {CtxLoad.displayLoadingBtn ?
                        <button type="button" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow cursor-not-allowed relative flex justify-center items-center"><BtnLoader /></button>
                        :
                        <button type="submit" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow">اعمال</button>
                    }
                    <Link to='/p/users'>
                        <button type="button" className="w-[100px] h-[40px] bg-[#a4a4a4] text-dayan-gray-200 rounded-[5px] mr-3 text-sm shadow">بازگشت</button>
                    </Link>
                </div>

            </form>

            <CModal visible={visibleImageModal} setVisible={setVisibleImageModal} radius={'10px'} uId={'Mo-add-profile'} >
                <div className=" w-full flex flex-col">
                    <Cropper
                        style={{ height: 300, width: "100%", borderRadius: "30px" }}
                        zoomTo={0.5}
                        initialAspectRatio={1}
                        preview=".img-preview"
                        src={image}
                        viewMode={1}
                        minCropBoxHeight={10}
                        minCropBoxWidth={10}
                        background={false}
                        responsive={true}
                        autoCropArea={1}
                        checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                        onInitialized={(instance) => {
                            setCropper(instance);
                        }}
                        guides={true}
                    />
                    <div className=" w-full mt-[20px] flex justify-center items-center">

                        <button type={'button'} onClick={getCropData} className=" w-[80px] mx-2 h-10 bg-dayan-orange-50  flex items-center justify-center rounded-[5px] text-white relative ">
                            <span>برش</span>
                        </button>
                        <button type={'button'} onClick={() => { setVisibleImageModal(false) }} className=" w-[80px] mx-2 h-10 bg-dayan-gray-200  flex items-center justify-center rounded-[5px] text-white">
                            <span>لغو</span>
                        </button>

                    </div>
                </div>
            </CModal>

        </div>
    )
}

export const monthList = [
    {
        'key': 'فروردین',
        'value': 1,
    },
    {
        'key': 'اردیبهشت',
        'value': 2,
    },
    {
        'key': 'خرداد',
        'value': 3,
    },
    {
        'key': 'تیر',
        'value': 4,
    },
    {
        'key': 'مرداد',
        'value': 5,
    },
    {
        'key': 'شهریور',
        'value': 6,
    },
    {
        'key': 'مهر',
        'value': 7,
    },
    {
        'key': 'آبان',
        'value': 8,
    },
    {
        'key': 'آذر',
        'value': 9,
    },
    {
        'key': 'دی',
        'value': 10,
    },
    {
        'key': 'بهمن',
        'value': 11,
    },
    {
        'key': 'اسفند',
        'value': 12,
    },
]

export const yearsList = [
    '1330',
    '1331',
    '1332',
    '1333',
    '1334',
    '1335',
    '1336',
    '1337',
    '1338',
    '1339',
    '1340',
    '1341',
    '1342',
    '1343',
    '1344',
    '1345',
    '1346',
    '1347',
    '1348',
    '1349',
    '1351',
    '1352',
    '1353',
    '1354',
    '1355',
    '1356',
    '1357',
    '1358',
    '1359',
    '1360',
    '1361',
    '1362',
    '1363',
    '1364',
    '1365',
    '1366',
    '1367',
    '1368',
    '1369',
    '1370',
    '1371',
    '1372',
    '1373',
    '1374',
    '1375',
    '1376',
    '1377',
    '1378',
    '1379',
    '1380',
    '1381',
    '1382',
    '1383',
    '1384',
    '1385',
    '1386',
    '1387',
    '1388',
    '1389',
    '1390',
    '1391',
    '1392',
    '1393',
    '1394',
    '1395',

]